module.exports = __webpack_public_path__ + "img/Mini_arrow_left2.d75b4007.png";